/* eslint-disable react-hooks/exhaustive-deps */
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DateRangePicker } from "rsuite";
import peticionBack from "../../../libs/peticiones/peticionBack";
import createURL from "../../../libs/peticiones/url";
import CardC from "../../../components/CustomCard/CardC";
import { colors } from "./variables";

const defConfig = {
    options: {
        chart: { 
            type: "bar",
            stacked: true,
        },
        xaxis: {
          categories: ["Archivos"]
        },
        colors: [colors.teal],
        plotOptions: {
          bar: {
            columnWidth: '70%',
            distributed: true,
          }
        },
        legend: {
          show: false
        },
        // noData: {
        //     text: "Cargando..."
        // }
      } as ApexOptions,
    series: [] as any[]
}

export default function UploadedFilesChart(){
    const [dates, setDates] = useState<Date[]|null>(null);
    const [config, setConfig] = useState(defConfig);

    useEffect(()=>{
        getData();
    }, [dates]); 

    async function getData() {
        let url = createURL("/reportes/files/count", [
            { name: "startDate", value: cleanDate(0)},
            { name: "endDate", value: cleanDate(1) },
        ]);
        const cpy = { ...defConfig }
        const res = await peticionBack({}, url, "GET", false);
        if(res && res.length > 0){
            const ttFiles = (res as Array<any>).reduce((acc, d) => acc + d.total, 0);
            cpy.series = [{ name: "Archivos", data: [ttFiles] }];
        }else{
            cpy.series = [];
        }
        setConfig(cpy);
    }

    function cleanDate(pos: number){
        if(!dates) return "";
        let str = dates[pos].toISOString().split("T")[0];
        if(pos === 0) str += "T00:00:00Z";
        else  str += "T23:59:59Z";
        return str;
    }

    return(
        <CardC className="mb-4">
            <div className="d-flex flex-md-row flex-column justify-content-md-between mb-2">
                <h6>Archivos Subidos</h6>
                <DateRangePicker 
                    size="xs" 
                    appearance="subtle"
                    placeholder="Fechas" 
                    style={{ width: "auto" }} 
                    onChange={(e)=> setDates(e)}
                    preventOverflow
                    placement="auto"
                />
            </div>
            <div className="border">
                <Chart options={config.options} series={config.series} type="bar" height={300}/>
            </div>
        </CardC>
    )
}